import { combineReducers } from 'redux';
import Auth from '../Pages/Auth/store/Auth.reducer';
import BomLibrary from '../Pages/Library/BomLibrary/store/BomLibrary.reducer';
import ColorLibrary from '../Pages/Library/ColorLibary/store/ColorLibrary.reducer';
import SupportingDocument from '../Components/SupportingDocument/store/SupportingDocument.reducer';
import BOMConfigReducer from '../Pages/DevlopmentOrder/Bom/store/BOMConfig.reducer';
import BomTypeReducer from '../Pages/Library/BomType/Store/BomType.reducer';
import previousReducer from '../Pages/DevlopmentOrder/Bom/store/previousConfig.reducer';
import SuppliersReducer from '../Pages/Supplier/store/Supplier.reducer';
import UsersReducer from '../Pages/UserSetting/store/User.reducer';
import DevelopmentOrderReducer from '../Pages/DevlopmentOrder/store/DevelopmentOrder.reducer';
import SupplierSuggestionReducer from '../Pages/SupplierSuggestion/store/SupplierSuggestion.reducer';
import TestReducer from '../Pages/Library/Testing/Store/Testing.reducer';
import PomReducer from '../Pages/Library/Pom/Store/Pom.reducer';
import SystemMastersReducer from '../Pages/SystemMasters/Store/SystemMasters.reducer';
import CostingTemplateReducer from '../Pages/Library/CostingTemplateTSX/store/costingTemplate.reducer';
import ProductCostingReducer from '../Pages/DevlopmentOrder/ProductCosting/store/ProductCostingReducer.reducer';
import SampleTodoListReducer from '../Pages/Dashboard/TodoList/Samples/store/TodoList.reducer';
import ProductAttributeReducer from '../Pages/DevlopmentOrder/ProductBomModal/store/product.reducer';
import PlaceholderManagementReducer from '../Pages/PlaceholderManagementTSX/store/placeholder.reducer';
import PlanningActualReducer from '../Pages/PlanningActual/store/PlanningActual.reducer';
import suggestionTodoListReducer from '../Pages/Dashboard/TodoList/Suggestions/store/Suggestion.reducer';
import costingTodoListReducer from '../Pages/Dashboard/TodoList/CostingTsx/store/Costing.reducer';
import ProductListReducer from '../Pages/RangePlan/ProductList/store/ProductList.reducer';
import purchaseTodoListReducer from '../Pages/Dashboard/TodoList/PurchaseOrder/store/Purchase.reducer';
import customSectionsReducer from '../Pages/RangePlan/ProductList/store/CustomSections.reducer';
import purchaseOrderReducer from '../Pages/DevlopmentOrder/PurchaseOrder/Store/PurchaseOrder.reducer';
import indicatorTodoListReducer from '../Pages/Dashboard/TodoList/ProgressIndicator/store/Indicator.reducer';
import PlanningBottomReducer from '../Pages/PlanningBottomUp/store/PlanningBottom.reducer';
import poTemplateReducer from '../Pages/Library/P.O.Template/store/POTemplate.reducer';
import oprationalCPReducer from '../Pages/OprationalCP/store/Oprationalcp.reducer';
import ProductCPReducer from '../Pages/ProductCP/store/ProductCP.reducer';
import productHistoryReducer from '../Pages/ProductHistory/store/ProductHistory.reducer';
import submitTodoListReducer from '../Pages/Dashboard/TodoList/SubmitDownloadTodo/store/Submit.reducer';
import SubmitDownloadReducer from '../Pages/DevlopmentOrder/SubmitDownload/Store/Submit.reducer';
import MultiProductSelectReducer from '../Pages/DevlopmentOrder/ProductInformation/MultiProductCostingSubmit/store/MultiProductSelect.reducer';
import FreightDutyReducer from '../Pages/Library/FreightAndDuty/store/FreightDuty.reducer';
import CareLabelConfigReducer from '../Pages/DevlopmentOrder/CareLabels/store/CARELABEL.reducer';
import CareLabelReducer from '../Pages/Library/CareLabel/store/CareLabel.reducer';
import NotificationReducer from '../Pages/UserNotification/store/notification.reducer';
import ComponentConfigReducer from '../Pages/ComponentOrder/store/component.reducer';
import testingTodoListReducer from '../Pages/Dashboard/TodoList/Testing/store/Testing.reducer';
import CustomModuleReducer from '../Pages/Library/CustomModule/Store/CustomModule.reducer';
import CompanyRightsReducer from '../Pages/CompanyRights/store/Companyrights.reducer';
import SpecTemplateReducer from '../Pages/Library/SpecTemplate/Store/SpecTemplate.reducer';
import measurmentDocumentReducer from '../Pages/DevlopmentOrder/Measurment/Store/Measurement.reducer';
import DamReducer from '../Pages/DAM/store/DAM.reducer';
import DamFolderReducer from '../Pages/Library/DamFolder/store/DamFolder.reducer';
import UploaderReducer from '../Pages/UploaderRedux/store/uploader.reducer';
import DAMHistoryReducer from '../Pages/DAM/DamHistory/store/DamHistory.reducer';
import DamProductFileReducer from '../Pages/DevlopmentOrder/Dam/DamFiles/store/DamFile.reducer';
import DamProductFolderReducer from '../Pages/DevlopmentOrder/Dam/DamFolder/store/DamFolder.reducer';
import DPPReducer from '../Pages/Library/DPP/Store/DPP.reducer';
import SupplierTodoReducer from '../Pages/Dashboard/TodoList/SupplierTodoList/store/SupplierToDo.reducer';
import UserInstructionReducer from '../Pages/Library/UserInstructionLibrary/store/UserInstruction.reducer';
import DPPProductReducer from '../Pages/DevlopmentOrder/DPPModule/store/DPPModule.reducer';
import SystemCanvasModuleReducer from '../Pages/DevlopmentOrder/SystemCanvasModule/store/SystemCanvasModule.reducer';
import DocumentReducer from '../Pages/ManualDocument/store/Document.reducer';
import purchaseOrderTemplateReducer from '../Pages/Library/PurchaseOrderTemplate/store/POTemplate.reducer';
import NewProductCostingReducer from '../Pages/DevlopmentOrder/ProductCostingTSX/store/productCosting.reducer';
import productPurchaseOrderReducer from '../Pages/DevlopmentOrder/ProductPurchaseOrder/Store/productPurchaseOrder.reducer';
import productPurchaseOrderTodoReducer from '../Pages/Dashboard/TodoList/ProductPurchaseOrderTodo/store/productPurchaseOrderTodo.reducer';
import RangePlanCustomSectionsReducer from '../Pages/RangePlan/ProductList/store/CustomSections.reducer';
import ChatReducer from '../Pages/Chat/store/chat.reducer';
import ControlLibraryReducer from '../Pages/Library/ControlLibrary/store/ControlLibrary.reducer';
import myTodoReducer from '../Pages/Dashboard/TodoList/MyTodo/store/my-todo.reducer.ts';
import AssetLibraryFilterReducer from '../Pages/SystemMasters/AssetLibrary/store/assetLibraryFilter.reducer';
import AssetLibraryHomeReducer from '../Pages/AssetLibrary/store/asset-library-home.reducer';
import SupportingDocumentTodoListReducer from '../Pages/Dashboard/TodoList/SupportingDocument/store/SupportingDocumentToDo.reducer';
import AssetLibraryAssetsReducer from '../Pages/AssetLibrary/Assets/store/asset.reducer';
import PIMReducer from '../Pages/PIM/store/pim.reducer';
import PIMHistoryReducer from '../Pages/PIM/store/pim-history.reducer';
import PIMChatReducer from '../Pages/Chat/store/PIMChat.reducer';
import BomLibraryV2Reducer from '../Pages/Library/BomLibraryV2/store/bom-library-v2.reducer';

const rootReducer = combineReducers({
  UserDetails: Auth,
  BomLibraryDetails: BomLibrary,
  BomLibraryV2Details: BomLibraryV2Reducer,
  ColorLibraryDetails: ColorLibrary,
  BOMConfigDetails: BOMConfigReducer,
  BomTypeDetails: BomTypeReducer,
  PreviousDetails: previousReducer,
  SuppliersDetails: SuppliersReducer,
  SupportingDocument,
  Users: UsersReducer,
  Measuremets: DevelopmentOrderReducer,
  SupplierSuggestion: SupplierSuggestionReducer,
  PomDetails: PomReducer,
  TestDetails: TestReducer,
  SystemMastersDetails: SystemMastersReducer,
  AssetLibraryFilters: AssetLibraryFilterReducer,
  AssetLibraryHome: AssetLibraryHomeReducer,
  AssetLibraryAssets: AssetLibraryAssetsReducer,
  CostingTemplateData: CostingTemplateReducer,
  ProductCostingData: ProductCostingReducer,
  ProductAttributeDetails: ProductAttributeReducer,
  PlaceholderDetails: PlaceholderManagementReducer,
  SampleTodoListData: SampleTodoListReducer,
  PlanningActualData: PlanningActualReducer,
  SuggestionTodoListData: suggestionTodoListReducer,
  CostingTodoListData: costingTodoListReducer,
  ProductListData: ProductListReducer,
  PurchaseTodoListData: purchaseTodoListReducer,
  customSectionData: customSectionsReducer,
  purchaseOrderData: purchaseOrderReducer,
  productPurchaseOrderReducer,
  IndicatorTodoListData: indicatorTodoListReducer,
  PlanningBottomReducer,
  poTemplateData: poTemplateReducer,
  oprationalCPDetails: oprationalCPReducer,
  ProductCPReducer,
  productHistoryDetails: productHistoryReducer,
  submitTodoListReducer,
  SubmitDownloadReducer,
  MultiProductSelectReducer,
  FreightDutyReducer,
  CareLabelProductReducer: CareLabelConfigReducer,
  CareLabelReducer,
  UserNotificationDetails: NotificationReducer,
  ComponentOrderReducer: ComponentConfigReducer,
  TestingTodoListData: testingTodoListReducer,
  CustomModuleReducer,
  CompanyRightsReducer,
  SpecTemplateData: SpecTemplateReducer,
  measurmentDocumentReducer,
  damModule: DamReducer,
  damFolderData: DamFolderReducer,
  uploader: UploaderReducer,
  damHistory: DAMHistoryReducer,
  damProductFileModule: DamProductFileReducer,
  damProductFolderModule: DamProductFolderReducer,
  DPPReducer,
  SupplierTodoModule: SupplierTodoReducer,
  UserInstructionDetails: UserInstructionReducer,
  DPPProductReducer,
  SystemCanvasModuleReducer,
  DocumentReducer,
  purchaseOrderTemplateReducer,
  newProductCostingData: NewProductCostingReducer,
  productPurchaseOrderTodoReducer,
  rangePlanCustomSections: RangePlanCustomSectionsReducer,
  ChatDetails: ChatReducer,
  ControlLibraryReducer,
  PIM: PIMReducer,
  pimHistory: PIMHistoryReducer,
  PIMChat: PIMChatReducer,
  SupportingDocumentTodoListData: SupportingDocumentTodoListReducer,
  MyTodoDetails: myTodoReducer,
});

export default rootReducer;
